import { render } from "./ButtonSwiper.vue?vue&type=template&id=4795da4e&scoped=true"
import script from "./ButtonSwiper.vue?vue&type=script&lang=js"
export * from "./ButtonSwiper.vue?vue&type=script&lang=js"

import "./ButtonSwiper.vue?vue&type=style&index=0&id=4795da4e&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4795da4e"]])

export default __exports__